import queryString from "query-string";
import { useQuery } from "react-query";
import {
    GetPenyewaHistoryResponse,
} from "../../constants/types";
import axios from "../axios";

const handleRequest = async (
    id: number,
) => {
    const apiUrl = queryString.stringifyUrl({
        url: `/api/mpenyewas/${id}`,
    });
    const { data } = await axios.get<GetPenyewaHistoryResponse>(apiUrl);
    return data.data;
};

export default function useHistoryPenyewa(id: number, enabled: boolean) {
    return useQuery<GetPenyewaHistoryResponse["data"]>(
        ["detailPenyewa", id],
        () => handleRequest(id),
        { enabled: !!id && enabled }
    );
}
